import { omdApi } from 'bus/api';

import { TransportBrandItem } from './types';

const transportBrandApi = omdApi.injectEndpoints({
    endpoints: (builder) => ({
        getTransportBrandDetail: builder.query<TransportBrandItem, { id: number }>({
            query: ({ id }) => ({
                url: `/v1/transportModel/${id}`,
            }),
        }),

        createTransportBrand: builder.mutation<void, Omit<TransportBrandItem, 'id'>>({
            query: (data) => ({
                url: '/v1/transportModel',
                method: 'POST',
                body: data,
            }),
        }),

        editTransportBrand: builder.mutation<void, TransportBrandItem>({
            query: (data) => ({
                url: `/v1/transportModel/${data.id}`,
                method: 'PUT',
                body: data,
            }),
        }),

        deleteTransportBrand: builder.mutation<void, { id: number }>({
            query: ({ id }) => ({
                url: `/v1/transportModel/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
});

export const {
    useGetTransportBrandDetailQuery,
    useLazyGetTransportBrandDetailQuery,
    useCreateTransportBrandMutation,
    useEditTransportBrandMutation,
    useDeleteTransportBrandMutation,
} = transportBrandApi;


